import { render, staticRenderFns } from "./MediareportList.vue?vue&type=template&id=513aba3a&scoped=true&"
import script from "./MediareportList.vue?vue&type=script&lang=js&"
export * from "./MediareportList.vue?vue&type=script&lang=js&"
import style0 from "./MediareportList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MediareportList.vue?vue&type=style&index=1&id=513aba3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513aba3a",
  null
  
)

export default component.exports